export default __webpack_public_path__ + "static/media/bq-se.66ad3466.svg";